const INITIAL_STATE = {
  data: [],
  config: {
    voipdeviceindex: 0,
    password: '',
    sipserver: '',
    sipport: '',
    users: []
  },
  ivrOptions: [],
  isFetching: false,
  addSuccess: false,
  addError: false,
  editSuccess: false,
  editError: false,
  removeSuccess: false,
  removeError: false,
  getAllError: false,
  errorContent: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'IVRS_START_REQUEST':
      return {
        ...state,
        isFetching: true,
        addError: false,
        editError: false,
        errorContent: ''
      };
    case 'IVRS_END_REQUEST':
      return {
        ...state,
        addSuccess: false,
        editSuccess: false,
        removeSuccess: false,
        isFetching: false
      };
    case 'IVRS_GET_ALL_SUCCESS':
      return {
        ...state,
        data: payload
      };
    case 'IVRS_GET_ALL_ERROR':
      return {
        ...state,
        getAllError: true,
        errorContent: payload
      };
    case 'IVRS_ADD_SUCCESS':
      return {
        ...state,
        data: state.data.concat([payload]),
        addSuccess: true,
        addError: false
      };
    case 'IVRS_ADD_ERROR':
      return {
        ...state,
        addSuccess: false,
        addError: true,
        errorContent: payload
      };
    case 'IVRS_EDIT_SUCCESS':
      return {
        ...state,
        data: state.data.map(item =>
          item._id !== payload._id ? { ...item } : { ...payload }
        ),
        editSuccess: true,
        editError: false
      };
    case 'IVRS_EDIT_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'IVRS_REMOVE_SUCCESS':
      return {
        ...state,
        removeSuccess: true,
        removeError: false,
        data: state.data.map(item =>
          item._id !== payload ? { ...item } : { ...item, active: false }
        )
      };
    case 'IVRS_REMOVE_ERROR':
      return {
        ...state,
        removeSuccess: false,
        removeError: true,
        errorContent: payload
      };
    case 'IVRS_OPTIONS_EDIT_SUCCESS':
      return {
        ...state,
        data: state.data.map(item =>
          item._id !== payload.ivr._id ? { ...item } : { ...payload.ivr }
        ),
        ivrOptions: state.ivrOptions
          .filter(ivrOption => ivrOption.ivr !== payload.ivr._id)
          .concat(payload.ivrOptions),
        editSuccess: true,
        editError: false
      };
    case 'IVRS_OPTIONS_EDIT_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'IVRS_OPTIONS_GET_ALL_SUCCESS':
      return {
        ...state,
        ivrOptions: payload
      };
    case 'IVRS_OPTIONS_GET_ALL_ERROR':
      return {
        ...state,
        getAllError: true,
        errorContent: payload
      };
    case 'IVRS_GET_ALL_CONFIG_SUCCESS':
      return {
        ...state,
        config:
          payload[0] && typeof payload[0] === 'object'
            ? { ...state.config, ...payload[0] }
            : { ...state.config }
      };
    case 'IVRS_GET_ALL_CONFIG_ERROR':
      return {
        ...state,
        getAllError: true,
        errorContent: payload
      };
    case 'IVRS_SET_ALL_CONFIG_SUCCESS':
      return {
        ...state,
        config: { ...state.config, ...payload },
        editSuccess: true,
        editError: false
      };
    case 'IVRS_SET_ALL_CONFIG_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'IVRS_MODIFY_STORE': {
      const ids = payload.map(item => item._id);
      const items = state.data.filter(item => !ids.includes(item._id));
      return {
        ...state,
        data: items.concat(payload)
      };
    }
    default:
      return { ...state };
  }
};

export default reducer;
